export const SELECT_ALL_ID = '__SELECT_ALL__' as const;

export interface SelectAllSentinel {
  id: typeof SELECT_ALL_ID;
  name: string;
}

export type WithSentinel<T> = T | SelectAllSentinel;

export function isSelectAllSentinel<T>(item: WithSentinel<T>): item is SelectAllSentinel {
  return (item as SelectAllSentinel).id === SELECT_ALL_ID;
}
